import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/dist/query/react'

const pageApi2 = createApi({
    reducerPath: 'pageApi2',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_BASE || '/lixiang/v25'
    }),
    tagTypes: 'students',
    endpoints(build) {
        return {

            sms: build.mutation({
                query(data) {
                    return {
                        url: 'sms_code',
                        method: 'post',
                        body: {...data}
                    }
                },
            }),
            login: build.mutation({
                query(data) {
                    return {
                        url: 'login',
                        method: 'post',
                        body: {...data}
                    }
                },
            }),
            
            info: build.mutation({
                query(data) {
                    return {
                        url: 'info',
                        method: 'post',
                        body: {...data}
                    }
                },
            }),
            update: build.mutation({
                query(data) {
                    return {
                        url: 'update',
                        method: 'post',
                        body: {...data}
                    }
                },
            }),
            times: build.mutation({
                query(data) {
                    return {
                        url: 'times',
                        method: 'post',
                        body: {...data}
                    }
                },
            }),
            table: build.mutation({
                query(data) {
                    return {
                        url: `table?name=${data.name}`,

                    }
                },
            }),
            phone: build.mutation({
                query(data) {
                    return {
                        url: `table?name=${data.name}&&phone=${data.phone}`,

                    }
                },
            }),
        }
    }
})

export const {
    useSmsMutation,
    useLoginMutation,
    useInfoMutation,
    useUpdateMutation,
    useTimesMutation,
    useTableMutation,
    usePhoneMutation,
} = pageApi2

export default pageApi2